exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".impressum{text-align:left;margin-bottom:5rem}.impressum p{margin-bottom:0}", "", {"version":3,"sources":["C:/projects/Infrastil/evm/evm-frontend-react/src/components/layout/Header/Impressum.scss"],"names":[],"mappings":"AAAA,WACE,gBAAiB,AACjB,kBAAoB,CAAE,AACtB,aACE,eAAiB,CAAE","file":"Impressum.scss","sourcesContent":[".impressum {\n  text-align: left;\n  margin-bottom: 5rem; }\n  .impressum p {\n    margin-bottom: 0; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":false,"sourceMap":true,"minimize":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js!./src/components/layout/Header/Impressum.scss
// module id = 1599
// module chunks = 0